import React from 'react';
import PropTypes from 'prop-types';

const Pager = ({ page, isLastPage, disabled, onChange }) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <button
      className={(page === 0 || disabled) ? 'small disabled' : 'small'}
      disabled={page === 0 || disabled}
      onClick={() => onChange(page - 1)}
    >
      ‹ Prev
    </button>
    <span style={{ margin: '0 1.25rem', color: '#9090a0' }}>Page {page + 1}</span>
    <button
      className={(isLastPage || disabled) ? 'small disabled' : 'small'}
      disabled={isLastPage || disabled}
      onClick={() => onChange(page + 1)}
    >
      Next ›
    </button>
  </div>
);

Pager.propTypes = {
  page: PropTypes.number.isRequired,
  isLastPage: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

Pager.defaultProps = {
  disabled: false,
};

export default Pager;



/** WEBPACK FOOTER **
 ** ./src/containers/large-campaign/pager.js
 **/